/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import hash from 'object-hash';
import { v5 } from 'uuid';

function generateUUID() {
  // Sample UUID : 4c366545-aa61-4c66-75b6-0f2a712c8ff0
  return 'xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, () => {
    const v = Math.floor(Math.random() * 16);
    return v.toString(16);
  });
}

// Generate UUID based on object content
// This is useful when we want to generate a UUID for an object,
// which remains the same every time the same object is passed
export function generateObjectUUID(obj: any): string {
  return v5(hash(obj), v5.URL);
}

export default generateUUID;
